(function ($) {
  Drupal.behaviors.supercatProductLayoutV1 = {
    attached: false,
    attach: function (context) {
      var self = this;
      if (self.attached) {
        return;
      }
      self.attached = true;
      var $template = $('.js-supercat-container', context);
      var $header = $('.js-supercat-header', $template)
      var $productGrid = $('.js-supercat-grid', $template);

      if ($productGrid.find('.mpp-grid--carousel').length !== 0) {
        $header.removeClass('sticky-header');
      }
    }
  };
})(jQuery);
